import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useUpdateAiCreditCountMutation } from '@crew/apis/contract/contractApis'

export type FormValues = {
  aiCredit: number
}
const formInitialValues: FormValues = {
  aiCredit: 0,
}
export const useContractPurchaseAiCreditPage = () => {
  const { control, handleSubmit, setValue } = useForm<FormValues>({
    criteriaMode: 'all',
    defaultValues: formInitialValues,
  })

  // AIクレジット変更用の関数を取得
  const [
    updateAiCreditCountMutation,
    { isLoading: isLoadingUpdateAiCreditCount },
  ] = useUpdateAiCreditCountMutation()

  // AIクレジット変更処理
  const updateAiCredit = useCallback(
    async (aiCreditCount: number) => {
      await updateAiCreditCountMutation({
        subscriptionAiCreditCount: aiCreditCount,
      }).unwrap()
    },
    [updateAiCreditCountMutation]
  )

  return {
    control,
    handleSubmit,
    setValue,
    updateAiCredit,
    isLoadingUpdateAiCreditCount,
  }
}
